/* eslint-disable import/no-unresolved */
import { getText } from '../app/internal/TextLabels'

export const modules = {
  reconciliationApp: {
    name: 'reconciliationApp',
    basePath: '/reconciliation',
    app: () => import('reconciliationApp/appInjector'),
    menu: () => import('reconciliationApp/appMenuPopulator'),
  },
  paymentManagementApp: {
    name: 'paymentManagementApp',
    basePath: '/payment-management',
    app: () => import('paymentManagementApp/appInjector'),
    menu: () => import('paymentManagementApp/appMenuPopulator'),
    icon: 'midasCashRegister',
    menuTitle: getText('menu.main.transactions'),
  },
}
